module.exports = __webpack_public_path__ + "media/סירה.8a239c91.mp3";